import { useAuth0 } from '@auth0/auth0-react'
import { createContext, FC, useEffect, useMemo, useState } from 'react'
import { decodeToken } from 'react-jwt'

import useUserData from '@hook/shared/use-userdata'

import AuthAuthorize from '@view/Auth/Authorize'
import AuthError from '@view/Auth/Error'

export interface IAuth {
  role?: string
  isSchedulling?: boolean
  token?: string
  companies?: Array<number>
  userId?: string
  setLoading?: (state: boolean) => void
}

const AuthProvider: FC = ({ children }) => {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { user: userData } = useUserData()

  const [token, setToken] = useState<string>()

  const [loading, setLoading] = useState(true)
  const [error] = useState(false)
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const { loginWithRedirect, isLoading, user } = useAuth0()
  useEffect(() => {
    ;(async function login() {
      if (!isLoading && !user) {
        setLoading(false)
        await loginWithRedirect()
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  const role = useMemo<string>(() => {
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      )
    )
    setToken(userInfos?.body.access_token)
    if (userInfos) {
      setLoading(false)
      const tokenData: any = decodeToken(userInfos?.body.access_token)
      return tokenData.role
    }
    return null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, user])

  const isSchedulling = useMemo<boolean>(() => {
    if (token) {
      const tokenData: any = decodeToken(token)
      return tokenData?.hasSchedulingAccess === 'True'
    }
    return false
  }, [token])

  const userId = useMemo<string>(() => {
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      ) ?? '{}'
    )
    const tkn = userInfos?.body?.access_token
    if (!tkn) return ''
    const tokenData: any = decodeToken(tkn)
    return tokenData?.userid ?? ''
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, user])

  const companies = useMemo<Array<number>>(() => {
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      ) ?? '{}'
    )
    const token = userInfos?.body?.access_token

    if (!token) {
      return []
    }
    setLoading(false)

    const tokenData: any = decodeToken(token)
    return tokenData.companies ? tokenData.companies.split(',').map(Number) : []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, user])

  // const authorize = useCallback(async () => {
  //   const token = Cookies.get('SCLToken')
  //   if (!token) {
  //     localStorage.setItem('userSSO', userData.id_token)

  //     try {
  //       const {
  //         data: { data }
  //       } = await auth.session(userData.id_token)

  //       setToken(data.token)

  //       Cookies.set('SCLToken', data.token)
  //       Cookies.set('SCLRefreshToken', data.refreshToken)
  //     } catch (ex) {
  //       setError(true)
  //     }

  //     setLoading(false)
  //   } else {
  //     localStorage.setItem('userSSO', userData.id_token)
  //     setToken(token)
  //     setLoading(false)
  //   }
  // }, [userData])

  return (
    <AuthContext.Provider
      value={{ role, token, companies, isSchedulling, userId }}
    >
      {loading ? <AuthAuthorize /> : error ? <AuthError /> : children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
export const AuthContext = createContext<IAuth>({} as IAuth)
